// frontend/src/components/ui/spinner.jsx
// Updated with CSS variables for theming
import React from 'react';
import { cn } from '../../lib/utils';

export const Spinner = ({ className }) => (
  <div className={cn(
    "animate-spin rounded-full h-5 w-5 border-2 border-current border-t-transparent text-border-primary",
    className
  )} />
);

export default Spinner;